/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useTranslate } from 'hooks';
import { SponsorItem } from 'components/contexts/sponsors/SponsorItem';
import { Heading } from 'components/structure';
import { Skeleton } from './Sponsors.skeleton';
import * as S from './Sponsors.styles';
// import mock from './newsponsors.json'

const mock2 = [
  {
    category: 'Patrocínio',
    type: 'large',
    sponsors: [
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Atta.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Bahia.png',
        href: '',
      },
      {
        image:
          'https://s3.us-east-1.amazonaws.com/assets.tm1.com.br/ampro-2024/Group+20.png',
        href: '',
      },
      {
        image:
          'https://s3.us-east-1.amazonaws.com/assets.tm1.com.br/ampro-2024/Frame+1155.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Neto+Eventos.png',
        href: '',
      },
      {
        image:
          'https://s3.us-east-1.amazonaws.com/assets.tm1.com.br/ampro-2024/Frame+1157.png',
        href: '',
      },
    ],
  },
  //
  {
    category: 'Parceiro Institucional',
    type: 'large',
    sponsors: [
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/estacao.png',
        href: '',
      },
    ],
  },
  {
    category: 'Apoio Institucional',
    type: 'large',
    sponsors: [
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/A2R.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Angel.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/APTK.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/cava.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/CIA.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Chris.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/dala.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Diex.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Domo.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/dream.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/esg.png',
        href: '',
      },
      // {
      //   image:
      //     'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/estacao.png',
      //   href: '',
      // },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/FAP.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/FAS.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/fot.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/HEINEKEN.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/ICONE.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/ilumi.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/imperio.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/infinita.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/infinity+solutions.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/intouch.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/livre.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/LRG.png',
        href: '',
      },

      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/nubia.png',
        href: '',
      },

      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/ORI.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/pae.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/playport.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/porto.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/rabisco.png',
        href: '',
      },

      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/rec.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/santo.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/sympla.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/tele.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/think.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/tm1.png',
        href: '',
      },

      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/vita.png',
        href: '',
      },
      {
        image:
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/xirau.png',
        href: '',
      },
    ],
  },
];

export const Sponsors = () => {
  const translate = useTranslate();
  // const { data, isLoading } = useSponsors();
  const [data, setData] = useState<any>(mock2);
  useEffect(() => {
    (async () => {
      // const result = await fetch(process.env.REACT_APP_SPONSORS_BASE_PATH!)
      // const resultJson = await result.json()
      setData(mock2);
    })();
  }, []);
  if (!data) {
    return <Skeleton />;
  }

  return (
    <S.Wrapper>
      <Heading>{translate('labels.sponsors')}</Heading>
      <S.Content>
        {mock2?.map((sponsor: any) => (
          <SponsorItem key={sponsor.category} {...sponsor} />
        ))}
      </S.Content>
    </S.Wrapper>
  );
};
